import styled from 'styled-components';

import { mediaSmallOrTiny } from '@xing-com/layout-tokens';
import { spaceM } from '@xing-com/tokens';

export const TopContent = styled.div`
  display: flex;
  margin-top: ${spaceM};

  @media ${mediaSmallOrTiny} {
    min-height: 0;
  }
`;
